import React, { useRef, useState } from 'react'
import InfoContainer from 'components/UI/info/InfoContainer';
import InputWithPlaceholder from 'components/UI/main/input/InputWithPlaceholder';
import 'styles/css/main.css'
import 'styles/css/general.css'
import 'values.css'
import OptionTitle from 'components/UI/main/option/title/OptionTitle';
import DropDownContainer from 'components/UI/main/dropDown/DropDownContainer';
import QrGenerator from 'components/UI/qrCode/qrGenerator/QrGenerator';
import ColorPicker from 'components/UI/main/color/ColorPicker';
import TypeOption from 'components/UI/main/typeOption/TypeOption';
import Notifications from "components/UI/popupNotifications/Notifications";
import { NotificationManager } from 'react-notifications';
import Strings from 'values/Strings';
import { ContactOptions, AppearanceOptions } from 'components/UI/main/content/ContentOptions';
import { emptyContact, contactToVCard } from 'services/contact';
import { readSettings } from 'services/qrSettings';


export declare type DotsType = "dots" | "rounded" | "classy" | "classy-rounded" | "square" | "extra-rounded";
export declare type DotType = "dot" | "square" | "extra-rounded" | "none";
export declare type SquareType = "dot" | "square" | "extra-rounded" | "none";
declare type OpenAndCloseTypes = 'type' | 'colors'

function downloadJSONFile(data, filename) {
    const jsonData = JSON.stringify(data, null, 2); // Преобразуем данные в строку JSON с отступами

    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url); // Очищаем ссылку после скачивания
}

function MainPage() {

    const [value, setValue] = useState({
        // shape: 'square',
        // shape: 'circle',
        image: null,
        contentType: 'url',
        contact: { ...emptyContact },
        renderMode: 'standard',
        customPattern: 'diamond',
        artwork: null,
        artworkName: '',
        artStrength: 80,
        url: '',
        qrCodeSize: -1,
        backgroundColor: {
            type: "rounded",
            gradient: {
                type: "linear",
                rotation: 150,
                colorStops: [
                    {
                        offset: 0.3,
                        color: 'rgba(255,0,0,0)'
                    },
                ]
            }
        },
        dotsOptions: {
            type: "classy-rounded",
            gradient: {
                type: "linear",
                rotation: 150,
                colorStops: [
                    {
                        offset: 1,
                        color: 'rgba(0,0,0,1)'
                    }
                ]
            }
        },
        squareColors: {
            type: "extra-rounded",
            gradient: {
                type: "linear",
                rotation: 150,
                colorStops: [
                    {
                        offset: 1,
                        color: 'rgba(0,0,0,1)'
                    }
                ]
            }
        },
        dotColors: {
            type: "none",
            gradient: {
                type: "linear",
                rotation: 150,
                colorStops: [
                    {
                        offset: 1,
                        color: 'rgba(0,0,0,1)'
                    }
                ]
            }
        },
        imageOptions: {
            crossOrigin: "extra rounded",
            margin: 1,
            hideBackgroundDots: true,
            imageSize: 0.5,
        },
        pointColors: '',
    })

    const [openSection, setOpenSection] = useState<OpenAndCloseTypes | null>(null)
    const openAndCloseOptions = (type: OpenAndCloseTypes): void => {
        setOpenSection(current => current === type ? null : type)
    }

    const mainParamsProps = {
        data: { placeholder: 'Your URL', example: 'https://www.QRTrace.ru', valueKey: 'url', value: value, setValue: setValue },
        size: { placeholder: 'Qr Code Size', example: '300', valueKey: 'qrCodeSize', value: value, setValue: setValue, slider: true, min: 1, max: 2000 },
    }

    const [importVersion, setImportVersion] = useState(0);
    const copyParamsInBuffer = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(value));
            NotificationManager.success(Strings.notificationsCopyData, Strings.notificationsSuccessTitle, 2500);
        } catch { NotificationManager.error('Не удалось скопировать настройки.', Strings.notificationsErrorTitle, 3500); }
    }

    const colorPickerRef = useRef(null);
    const pastParamsInBuffer = async () => {
        try {
            const settings = readSettings(await navigator.clipboard.readText());
            setValue(old => ({ ...old, ...settings }));
            setImportVersion(old => old + 1);
            NotificationManager.success(Strings.notificationsClipboardData, Strings.notificationsSuccessTitle, 2500);
        } catch (error) { NotificationManager.error(error.message || 'Не удалось вставить настройки.', Strings.notificationsErrorTitle, 3500); }
    }

    const downloadParamsFile = () => {
        downloadJSONFile(value, 'QRTrace-settings.json')
    }


    return (
        <div className='mainWrapper'>
            <div className="infoContainer">
                <InfoContainer />
            </div>
            <div className="mainContent">
                <div className="optionsContainer">
                    <OptionTitle title='Main Options' />
                    <div className="mainParams">
                        <ContactOptions value={value} setValue={setValue} />
                        {value.contentType === 'url' && <InputWithPlaceholder marginTop={false} {...mainParamsProps.data} />}
                        <InputWithPlaceholder {...mainParamsProps.size} />
                    </div>
                    <OptionTitle title='Design' />
                    <div className="mainParams"><AppearanceOptions value={value} setValue={setValue} /></div>
                    {value.renderMode === 'standard' && <>
                    <OptionTitle title='Colors and Logo Options' expanded={openSection === 'colors'} controls='colors-options' onClick={() => openAndCloseOptions('colors')} />
                    <DropDownContainer id='colors-options' open={openSection === 'colors'}>
                        <ColorPicker key={importVersion} ref={colorPickerRef} defaultValue={[
                            { r: 255, g: 0, b: 0, a: 0.7 },
                            { r: 0, g: 255, b: 0, a: 0.7 },
                            { r: 0, g: 0, b: 255, a: 0.7 }
                        ]} value={value} setValue={setValue} />
                    </DropDownContainer>
                    <OptionTitle title='Type Options' expanded={openSection === 'type'} controls='type-options' onClick={() => openAndCloseOptions('type')} />
                    <DropDownContainer id='type-options' open={openSection === 'type'}>
                        <TypeOption value={value} setValue={setValue} />
                    </DropDownContainer>
                    </>}
                </div>
                <div className="fixedContainer">
                    <QrGenerator
                        copyParamsInBuffer={copyParamsInBuffer}
                        pastParamsInBuffer={pastParamsInBuffer}
                        downloadParamsFile={downloadParamsFile}
                        {...value}
                        data={value.contentType === 'contact' ? contactToVCard(value.contact) : value.url || 'https://www.QRTrace.ru'} />
                </div>
            </div>
            <Notifications />
        </div >
    );
}

export default MainPage;